<template>
  <div>
    <h1>{{entitie}}</h1>
    <canvas :id="'monitoring-chart-'+entitie"></canvas>
    <br />
    <br />

    <!-- <pre>{{areas}}</pre> -->
    <!-- <pre>{{participants_}}</pre> -->
  </div>
</template>
<script>
export default {
  props: {
    entitie: String,
    areas: Array,
    participants: Array
  },
  computed: {
    participants_() {
      return this.participants.filter(participant => {
        console.log(participant);

        if (
          participant &&
          participant.personalData &&
          participant.personalData.entity
        ) {
          console.log(participant.personalData.entity);

          if (participant.personalData.entity.option == this.entitie) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      });
    }
  },
  methods: {
    setChart() {
      var areas = [];
      var colors = [];
      var colorsBorder = [];
      this.areas.forEach(area => {
        colors.push("#3f51b54a");
        colorsBorder.push("#3f51b5");
        var participants = this.participants_.filter(participant => {
          console.log(participant);

          if (
            participant &&
            participant.personalData &&
            participant.personalData.entity
          ) {
            console.log(participant.personalData.entity);

            if (participant.personalData.area.option == area) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        });

        areas.push((participants.length / this.participants_.length) * 100);
      });

      console.log(areas);

      // console.log(entityParticipants, this.participants_.length);

      var ctx = document
        .getElementById("monitoring-chart-" + this.entitie)
        .getContext("2d");
      var myChart = new Chart(ctx, {
        type: "horizontalBar",
        data: {
          labels: this.areas,
          datasets: [
            {
              label: "Porcentaje de empleados",
              data: areas,
              backgroundColor: colors,
              borderColor: colorsBorder,
              borderWidth: 1
            }
          ]
        },
        options: {
          scales: {
            xAxes: [
              {
                ticks: {
                  max: 100,
                  beginAtZero: true
                }
              }
            ]
          }
        }
      });
    }
  },
  mounted() {
    this.setChart();
  }
};
</script>